'use strict';

var Json_decode = require("@glennsl/bs-json/lib/js/src/Json_decode.js");
var Caml_exceptions = require("rescript/lib/js/caml_exceptions.js");

function categoryToString(category) {
  switch (category) {
    case /* Melee */0 :
        return "melee";
    case /* Magic */1 :
        return "magic";
    case /* Ranged */2 :
        return "ranged";
    case /* Summoner */3 :
        return "summon";
    
  }
}

var UnknownCategory = /* @__PURE__ */Caml_exceptions.create("WeaponModel-PvpcontrollerWeb.UnknownCategory");

function category(json) {
  var categoryName = Json_decode.string(json);
  switch (categoryName) {
    case "magic" :
        return /* Magic */1;
    case "melee" :
        return /* Melee */0;
    case "ranged" :
        return /* Ranged */2;
    case "summon" :
        return /* Summoner */3;
    default:
      throw {
            RE_EXN_ID: UnknownCategory,
            Error: new Error()
          };
  }
}

function weapon(json) {
  var name = Json_decode.field("Name", Json_decode.string, json);
  var imageName = name.replace(/ /g, "_");
  return {
          netId: Json_decode.field("NetID", Json_decode.$$int, json),
          baseDamage: Json_decode.field("BaseDamage", Json_decode.$$int, json),
          baseVelocity: Json_decode.field("BaseVelocity", Json_decode.$$int, json),
          damage: Json_decode.field("CurrentDamage", Json_decode.$$int, json),
          maxDamage: Json_decode.field("MaxDamage", Json_decode.$$int, json),
          minDamage: Json_decode.field("MinDamage", Json_decode.$$int, json),
          image: "https://pvpmanager.dark-gaming.com/img/" + imageName + ".png",
          velocity: Json_decode.field("CurrentVelocity", Json_decode.$$int, json),
          category: Json_decode.field("WeaponType", category, json),
          banned: Json_decode.field("Banned", Json_decode.bool, json),
          name: name
        };
}

var Decode = {
  category: category,
  weapon: weapon
};

exports.categoryToString = categoryToString;
exports.Decode = Decode;
/* No side effect */
